import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Tutorial } from '../../models/tutorial.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { TutorialService } from '../../services/tutorial.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-tutorial-edit',
  templateUrl: './tutorial-edit.component.html',
  styleUrls: ['./tutorial-edit.component.scss', './../../tutorial.scss']
})
export class TutorialEditComponent extends BaseFormComponent<Tutorial> implements OnInit {

  actionLabel: string = 'Novo';
  data: Tutorial;
  selectedFile: File | null = null;
  @Input() id:number;
  @Input() type:string;
  @Output() closeModal = new EventEmitter<void>();

  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: TutorialService
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.loading();
    this.initForm();
    this.start();
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      time: new FormControl('')
    });
    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
    }
  }

  start(): void{
    if(this.id){
      this.myService.getById(this.id).subscribe(
        (res) => {
          this.entity = res;
          this.data = res;
          this.initForm();
          this.loaded();
        },
        (error) => {
          this.msgError(error?.error?.message);
          this.loaded();
        },
      )
    }
    else{
      this.loaded();
    }
  }

  getDataCreate(): Tutorial {
    return Object.assign({}, this.form.value);
  }
  
  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.myService.update(this.getDataCreate(), this.data?.id).subscribe({
          next: (res) => {
            this.confirmation("Tutorial alterado com sucesso!").subscribe(() => {
              window.location.reload();
            })
            this.loaded();
          },
          error: (error) => {
            let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
            this.msgError(msg);
            this.loaded();
          },
        })
      } else {
        this.myService.create(this.getDataCreate()).subscribe({
          next: (res) => {
            this.confirmation("Tutorial criado com sucesso!").subscribe(() => {
              window.location.reload();
            })
            this.loaded();
          },
          error: (error) => {
            let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
            this.msgError(msg);
            this.loaded();
          },
        })
      }
    } else {
      this.markAsDirty();
    }
  }

  onFileSelected(event: any): void {
    this.selectedFile = event?.target?.files[0];
  }

  onCloseModal(): void{
    this.closeModal.emit();
  }

}
